/**
 * Language Panel Site Switch Handler
 * 为语言面板添加站点切换记录功能
 */

(function () {
  'use strict';

  function initLanguagePanelHandler() {
    // 监听语言面板中的项目点击
    // 使用捕获阶段，确保在原始处理器之前执行
    document.addEventListener('click', function (event) {
      const item = event.target.closest('.language-currency-panel__item');
      if (!item) return;

      // 获取选择的国家和语言信息
      const countryIso = item.dataset.country;
      const languageIso = item.dataset.language;
      const link = item.dataset.link;

      if (!countryIso) return;

      // 检查是否启用了多站点功能
      if (!window.siteConfig || !window.MomcozyMultiSite) {
        return; // 不干扰原始跳转逻辑
      }

      // 判断用户选择的国家对应的站点
      const targetSiteKey = window.siteConfig.regionToSite[countryIso];
      const currentSiteKey = window.siteConfig.currentSiteKey;

      if (!targetSiteKey) {
        // 未配置的国家由主站承接：从区域站回到「主站覆盖」的国家时记录用户所选 ISO2（勿写入字面量 main）
        if (currentSiteKey !== 'main') {
          if (window.MomcozyMultiSite.setPreferredRegion) {
            window.MomcozyMultiSite.setPreferredRegion(countryIso);
          } else if (window.MomcozyMultiSite.setUserPreference) {
            window.MomcozyMultiSite.setUserPreference(countryIso);
          }
        }
        return;
      }

      // 如果目标站点与当前站点不同，记录用户地区偏好（ISO2）
      if (targetSiteKey !== currentSiteKey) {
        if (window.MomcozyMultiSite.setPreferredRegion) {
          window.MomcozyMultiSite.setPreferredRegion(countryIso);
        } else if (window.MomcozyMultiSite.setUserPreference) {
          window.MomcozyMultiSite.setUserPreference(countryIso);
        }
        
        // 触发自定义事件
        const customEvent = new CustomEvent('momcozy:site-switched', {
          detail: {
            siteKey: targetSiteKey,
            fromSite: currentSiteKey,
            country: countryIso,
          },
        });
        document.dispatchEvent(customEvent);
      } else {
        // 即使是同一个站点，也记录用户偏好（表示用户主动选择）
        if (window.MomcozyMultiSite.setPreferredRegion) {
          window.MomcozyMultiSite.setPreferredRegion(countryIso);
        } else if (window.MomcozyMultiSite.setUserPreference) {
          window.MomcozyMultiSite.setUserPreference(countryIso);
        }
      }
      
      // 不阻止事件传播，让原始的跳转逻辑继续执行
      // Cookie已经设置，原始逻辑会执行跳转
    }, true); // 使用捕获阶段，确保先于原始处理器执行

    // 监听货币选择器中手动配置的国家点击（用于跨站点跳转）
    document.addEventListener('click', function (event) {
      const manualItem = event.target.closest('[data-manual-country-item]');
      if (!manualItem) return;

      const countryIso = manualItem.dataset.country;
      if (!countryIso) return;

      // 阻止默认跳转行为（特别是 <a> 标签的默认行为）
      event.preventDefault();
      event.stopPropagation();

      // siteConfig 必须存在（始终由 multi-site-config.liquid 初始化）
      if (!window.siteConfig) {
        console.warn('[Currency Manual] window.siteConfig not found');
        return;
      }

      // 判断目标站点
      const targetSiteKey = window.siteConfig.regionToSite[countryIso];
      const currentSiteKey = window.siteConfig.currentSiteKey;

      if (!targetSiteKey) {
        console.warn(`[Currency Manual] No site mapping for country: ${countryIso}`);
        return;
      }

      // 记录用户偏好（MomcozyMultiSite 仅在 multi_site_enabled=true 时存在，可选）
      if (window.MomcozyMultiSite) {
        if (window.MomcozyMultiSite.setPreferredRegion) {
          window.MomcozyMultiSite.setPreferredRegion(countryIso);
        } else if (window.MomcozyMultiSite.setUserPreference) {
          window.MomcozyMultiSite.setUserPreference(countryIso);
        }
      }

      // 获取目标站点URL
      const targetSiteUrl = window.siteConfig.siteMapping[targetSiteKey];
      if (!targetSiteUrl) {
        console.warn(`[Currency Manual] No URL configured for site: ${targetSiteKey}`);
        return;
      }

      // 执行跳转
      window.location.href = targetSiteUrl;
    }, true); // 使用捕获阶段
  }

  // 初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLanguagePanelHandler);
  } else {
    initLanguagePanelHandler();
  }
})();
